import { addClass, removeClass, createDom } from 'xgplayer/src/utils/util';
import '../style/controls/error.scss';
import LoadedErrorIcon from '../assets/loaded-error.svg';

let s_error = function() {
  let player = this;
  let root = player.root;

  let error = createDom(
    'xg-error',
    `
      <div class="xgplayer-error-mask"></div>
      <div class="xgplayer-error-wrapper">
        <div class="xgplayer-error-icon">${LoadedErrorIcon}</div>
        <div class="xgplayer-error-tips" style="color: #f87171">加载失败</div>
      </div>
      <div class="xgplayer-error-btn-group">
        <div class="xgplayer-error-reload-btn xgplayer-error-btn">重新加载</div>
        <div class="xgplayer-error-next-btn xgplayer-error-btn">跳过这段内容</div>
      </div>
    `,
    {},
    'xgplayer-error'
  );
  player.once('ready', () => {
    root.appendChild(error);
  });

  let text = error.querySelector('.xgplayer-error-tips');
  let reloadBtn = error.querySelector('.xgplayer-error-reload-btn');
  let skipBtn = error.querySelector('.xgplayer-error-next-btn');
  let refresh = null;
  let next = null;

  function onError() {
    // player.controls.style.display = 'none'
    // if (player.error) {
    //   text.innerHTML = player.error
    // } else {
    if (player.config.lang && player.config.lang === 'zh-cn') {
      text.innerHTML = player.config.errorTips || `加载失败`;
      reloadBtn.innerHTML = '重新加载';
      skipBtn.innerHTML = '跳过这段内容';
    } else {
      text.innerHTML = player.config.errorTips || `Load Fail`;
      reloadBtn.innerHTML = 'reload';
      skipBtn.innerHTML = 'skip';
    }
    // }
    addClass(player.root, 'xgplayer-is-error');

    if (!refresh) {
      refresh = error.querySelector('.xgplayer-error-reload-btn');
      if (!refresh) return;
      ['touchend', 'click'].forEach((item) => {
        refresh.addEventListener(item, function(e) {
          e.preventDefault();
          e.stopPropagation();
          removeClass(player.root, 'xgplayer-is-error');
          addClass(player.root, 'xgplayer-is-enter');
          player.autoplay = true;
          // player.once('playing', () => {
          //   removeClass(player.root, 'xgplayer-is-error');
          // });
          setTimeout(() => {
            player.src = player.src;
          }, 800);
        });
      });
    }

    if (!next) {
      next = error.querySelector('.xgplayer-error-next-btn');
      if (!next) return;
      ['touchend', 'click'].forEach((item) => {
        next.addEventListener(item, function(e) {
          e.preventDefault();
          e.stopPropagation();
          player.emit('load-next-resources');
        });
      });
    }
  }
  player.on('error', onError);
  function onDestroy() {
    player.off('error', onError);
    player.off('destroy', onDestroy);
  }
  player.once('destroy', onDestroy);
};

export default {
  name: 's_error',
  method: s_error
};
